var image_viewer_rtlignore_default = {
  "fontElementMap": "hrVAz",
  "imageContainer": "BKrv3",
  "expandButton": "iC-6g",
  "expandIcon": "u-fwH",
  "pointer": "qQoD4",
  "imageWrapper": "kqD97",
  "imageRatio": "IuI01",
  "image": "bKf25",
  "imageOverlay": "OZS-J",
  "imagePreload": "YVMqO",
  "imageHighres": "_3Y6z3",
  "onlyHighRes": "TxLBO",
  "image_loading": "Vu1l8"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
